export const ATLASSIAN_SUPPORT_PORTALS_URL = 'https://gertec.atlassian.net/servicedesk/customer/portals';
